// The API's shared vocabulary: the base path, the one error shape, and the
// status the ops API answers with. The engine's own vocabulary (recovery
// counts, the upload activity window, the SSE stream) left with the engine.

export const API_VERSION = 'v1' as const
export const API_BASE = `/api/${API_VERSION}` as const

export type ApiErrorCode =
  | 'bad_request'
  | 'unauthorized'
  | 'forbidden'
  | 'not_found'
  | 'not_allowed'
  | 'conflict'
  | 'invalid_transition'
  | 'payload_too_large'
  | 'rate_limited'
  | 'unsupported'
  | 'internal'

/** The one error shape every endpoint returns. */
export interface ApiErrorBody {
  error: {
    code: ApiErrorCode
    message: string
    details?: unknown
  }
}

export type Environment = 'development' | 'staging' | 'production'

/** What the ops API's `/status` answers: build identity, nothing else yet. */
export interface OpsStatus {
  name: string
  version: string
  environment: Environment
}
